import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { infoPreguntasFormulario, infoTextCategoria } from "../../actions/configFormularioAction";
import { FormularioTextosAdmin }      from "./FormularioTextosAdmin";
import { FormularioConstantesAdmin }  from "./FormularioConstantesAdmin";
import { FormularioIndicadoresAdmin } from "./FormularioIndicadoresAdmin";
import { FormularioPDFAdmin } from "./FormularioPDFAdmin";
import { InformacionPreguntasAdmin } from "./InformacionPreguntasAdmin";

export default function FormularioAdmin({ vista }) {
    const dispatch = useDispatch();
    const { auth, configFormulario } = useSelector(state => state);

    useEffect(() => {
        if (auth?.tokenJwt && configFormulario?.infoFormularioTextCategoria == null) {
            dispatch(infoTextCategoria(auth.tokenJwt));
        }
    }, [auth?.tokenJwt, configFormulario?.infoFormularioTextCategoria, dispatch]);

    useEffect(() => {
        if (vista === 'info' && auth?.tokenJwt && configFormulario?.infoFormularioPreguntas == null) {
            dispatch(infoPreguntasFormulario(auth.tokenJwt));
        }
    }, [vista, auth?.tokenJwt, configFormulario?.infoFormularioPreguntas, dispatch]);

    if (vista === 'textos')      return <FormularioTextosAdmin />;
    if (vista === 'info')        return <InformacionPreguntasAdmin />;
    if (vista === 'constantes')  return <FormularioConstantesAdmin />;
    if (vista === 'indicadores') return <FormularioIndicadoresAdmin />;
    if (vista === 'pdf')         return <FormularioPDFAdmin />;
    // fallback por si vista no está definida aún
    return <FormularioConstantesAdmin />;
}
